import { render, staticRenderFns } from "./ReconhecimentoFacial.vue?vue&type=template&id=6f988850"
import script from "./ReconhecimentoFacial.vue?vue&type=script&lang=js"
export * from "./ReconhecimentoFacial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports